// Plex
export const PLEX_TOKEN = "PLEX_TOKEN";

// MB
export const MB_LOGIN = "MB_LOGIN";
export const MB_USER_ROLES = "MB_USER_ROLES";
export const MB_CONFIG_SETUP_START = "MB_CONFIG_SETUP_START";
export const MB_CONFIG_SETUP_END = "MB_CONFIG_SETUP_END";
export const MB_CONFIG_LOADED = "MB_CONFIG_LOADED";
export const MB_ACTIVE_SERVER = "MB_ACTIVE_SERVER";

// Metadata
export const POPULAR = "POPULAR";
export const SEARCH = "SEARCH";
export const MOVIE_LOOKUP = "MOVIE_LOOKUP";
export const MOVIE_LOOKUP_BATCH = "MOVIE_LOOKUP_BATCH";
export const SERIES_LOOKUP = "SERIES_LOOKUP";
export const SERIES_LOOKUP_BATCH = "SERIES_LOOKUP_BATCH";
export const PERSON_LOOKUP = "PERSON_LOOKUP";
export const SEASON_LOOKUP = "SEASON_LOOKUP";
export const STORE_ACTOR_MOVIE = "STORE_ACTOR_MOVIE";
export const STORE_ACTOR_SERIES = "STORE_ACTOR_SERIES";

export const LIBRARIES_INDEX = "LIBRARIES_INDEX";
export const LIBRARY_ALLOWED = "LIBRARY_ALLOWED";

// Request
export const GET_REQUESTS = "GET_REQUESTS";

// Reviews
export const GET_REVIEWS = "GET_REVIEWS";

// User
export const LOGIN_ADMIN = "LOGIN_ADMIN";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const CREDENTIALS = "CREDENTIALS";
export const CREDENTIALS_EMAIL = "CREDENTIALS_EMAIL";
export const UPDATE_QUOTA = "UPDATE_QUOTA";

// Nav
export const STORE_NAV = "STORE_NAV";
export const CLEAR_NAV = "CLEAR_NAV";
